import {
  Directive,
  Input,
  ElementRef,
  HostListener,
  Renderer2,
} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Directive({
    selector: '[appToolTip]',
    standalone: false
})
export class ToolTipDirective {
  @Input('appToolTip') tooltipTitle = '';
  @Input() placement = 'top';
  @Input() currentLanguage = 'en';
  @Input() specialClassAdded = 'none';
  private tooltipDiv: HTMLElement;
  private tooltip: HTMLElement;
  private offset = 5;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  /**
   * Method hand the mouse enter event
   * @method HostListener
   */
  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.show();
    }
  }
  @HostListener('touchstart') onTouchstart() {
    if (!this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.show();
    }
  }
  /**
   * Method hand the mouse leave event
   * @method HostListener
   */
  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.hide();
    }
  }

  @HostListener('touchend') onTouchEnd() {
    if (this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.hide();
    }
  }

  @HostListener('window:mouseup') onMouseUp() {
    if (this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.hide();
    }
  }

  /*  @HostListener('mouseup') onMouseUp() {
    if (this.tooltip && this.tooltipTitle && this.tooltipTitle.length > 0) {
      this.hide();
    }
  } */

  /**
   * Method show the tooltip
   * @method show
   */
  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  /**
   * Method hide the tooltip
   * @method hide
   */
  hide() {
    this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
    this.renderer.removeClass(this.tooltipDiv, 'ng-tooltip-show');
    this.renderer.removeChild(document.body, this.tooltip);
    this.renderer.removeChild(document.body, this.tooltipDiv);
    this.tooltip = null;
    this.tooltipDiv = null;
  }

  /**
   * Method create the tooltip
   * @method create
   */
  create() {
    // Tooltip

    this.tooltipDiv = document.createElement('div');
    this.renderer.addClass(this.tooltipDiv, this.currentLanguage);
    const newDiv1 = document.body.insertBefore(this.tooltipDiv, this.tooltip);
    this.tooltip = this.renderer.createElement('span');
    let elem = document.getElementById('main'); // ithis fixes made for javascript full screen functionality
    // textNode
    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipTitle)
    );
    this.renderer.appendChild(elem, this.tooltip);
    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    //console.log('this.specialClassAdded',this.specialClassAdded);
    if (this.specialClassAdded != 'none') {
      this.renderer.addClass(this.tooltip, this.specialClassAdded);
    }
    this.renderer.addClass(this.tooltip, 'ng-tooltip-style');
    this.renderer.addClass(this.tooltip, 'lang-specific-font-name');
    // this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
  }

  /**
   * Method set the tooltip position
   * @method setPosition
   */
  setPosition() {
    // el
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    // tooltip
    const tooltipPos = this.tooltip.getBoundingClientRect();
    // window scroll top
    // getBoundingClientRect viewport
    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    // Top and left
    let top: number, left: number;
    if (this.placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left =
        hostPos.left +
        window.visualViewport.offsetLeft +
        (hostPos.width - tooltipPos.width) / 2;
    }
    if (this.placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }
    if (this.placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }
    if (this.placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }
    // //console.log(' hostPos : ', hostPos, ' tooltipPos : ', tooltipPos, ' scrollPos : ', scrollPos, ' top : ', top, ' left : ', left);
    // Tooltip top & left set style
    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
